import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import rightIcon from '@/assets/chevron_right_gray.svg';
import { cn } from '@/utils/cn';
import { useState } from 'react';

const Collapsible = ({ 
  title, 
  hint,
  icon,
  children, 
  className,
  defaultOpen = false,
  variant = "default"
}) => {
  const [open, setOpen] = useState(defaultOpen);
  
  const baseStyles = variant === "faq" 
    ? "w-full bg-white border-t border-[#eeeeee] first:border-t-0" 
    : "w-full border rounded-md border-[#dddddd] bg-white";
  
  const titleStyles = variant === "faq"
    ? "text-sm"
    : "text-lg font-bold";
  
  return (
    <CollapsiblePrimitive.Root 
      open={open} 
      onOpenChange={setOpen} 
      className={cn(baseStyles, className)}
    >
      <CollapsiblePrimitive.Trigger className="flex w-full items-center justify-between py-3.5">
        <div className="flex items-start gap-4 flex-1">
          {icon && <img src={icon} alt="FAQ" className="w-5 h-5 flex-shrink-0" />}
          <span className={cn(titleStyles, "text-left flex-1 text-[#111111]")}>{title}</span>
        </div>
        {hint && (<span className="text-sm text-[#aaaaaa] mr-2">{hint}</span>)}
        <img 
          src={rightIcon} 
          className={cn(
            "w-6 h-6 flex-shrink-0 transition-transform",
            open ? "rotate-270" : "rotate-90"
          )}
          aria-hidden="true"
        />
      </CollapsiblePrimitive.Trigger>
      <CollapsiblePrimitive.Content className="pb-4">
        {children}
      </CollapsiblePrimitive.Content>
    </CollapsiblePrimitive.Root>
  );
};

export default Collapsible; 